'use client';

import Script from 'next/script';
import { AD_TRACKED_EVENTS, adEventName } from '@/app/lib/ad-events';
import { useCookieConsent } from '@/app/stores/cookie-consent-store';

const ANALYTICS_ID = 'G-H4J0ZTM526';
const ADS_ID = 'AW-17515999558';
const TAG_MANAGER_ID = 'GTM-TRQ75WBX';

const GoogleAnalytics = () => {
  const { isAccepted } = useCookieConsent();
  if (!isAccepted) return null;

  return (
    <>
      <Script src={`https://www.googletagmanager.com/gtag/js?id=${ANALYTICS_ID}`} strategy="afterInteractive" />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag('config', '${ANALYTICS_ID}');
          gtag('config', '${ADS_ID}');
          gtag('config', '${TAG_MANAGER_ID}');
        `}
      </Script>
    </>
  );
};

const gtagEvent = (event: string, params: Record<any, any>) => {
  if (typeof window !== 'undefined' && typeof (window as any).gtag === 'function') {
    (window as any).gtag('event', event, params);
  }
};

/**
 * Sends one event to Google Analytics, and to Google Ads as well when it is one the ad platforms are
 * sent (see lib/ad-events). Ads gets it under the ad platforms' name for it; Analytics keeps ours.
 *
 * Every event names its destinations: one that doesn't goes to all the ids configured above.
 */
export const sendGAEvent = (
  event: string,
  params: Record<any, any>,
  { ads = AD_TRACKED_EVENTS.has(event) }: { ads?: boolean } = {}
) => {
  gtagEvent(event, { ...params, send_to: [ANALYTICS_ID, TAG_MANAGER_ID] });
  if (ads) gtagEvent(adEventName(event), { ...params, send_to: ADS_ID });
};

export const sendGAConversionEvent = () => {
  const analyticEnabled = process.env.NODE_ENV === 'production';
  if (analyticEnabled) gtagEvent('conversion', { send_to: `${ADS_ID}/H4zJCPmemZsbEMbio6BB` });
};

export default GoogleAnalytics;
